interface Props {
  alt?: string;
  onClick?: () => void;
  onLoad?: (ev: any) => void;
}

const SCREENSAVER_URL = "https://timber.mhmcdn.com/site/content/digital-assets/your-screen-is-ready.webp";

export default function DsaScreensaver({ alt = "", onClick, onLoad }: Props) {
  return <img src={SCREENSAVER_URL} alt={alt} onClick={onClick} onLoad={onLoad} className="dsa-screensaver" />;
}
